import { useState } from "react";
import { History } from "lucide-react";
import { Panel, Loader, ErrorNote, Empty } from "./kit";

const when = (s) => {
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
};

export function CompLog({ entries, loading, error }) {
  const [filter, setFilter] = useState("All");
  const [q, setQ] = useState("");
  const list = Array.isArray(entries) ? entries : [];
  const latest = {};
  [...list].reverse().forEach((e) => { latest[e.team_id] = e; });
  const comped = Object.values(latest).filter((e) => e.enabled).length;
  const rows = list.filter((e) =>
    (filter === "All" || (filter === "Granted") === e.enabled) &&
    (!q || [e.team_name, e.owner_name, e.owner_email].some((v) => v?.toLowerCase().includes(q.toLowerCase())))
  );

  return (
    <Panel className="mt-10" data-testid="comp-log">
      <div className="mb-5 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="flex items-center gap-2 font-mono-gd text-xs uppercase tracking-[0.25em] text-[#39FF14]"><History className="h-4 w-4" />Free access log</p>
          <h2 className="mt-2 font-display text-3xl font-bold uppercase text-white">Who got comped, and when</h2>
          <p className="mt-1 text-sm text-slate-400">Every switch flipped on this page. <span data-testid="comp-log-active-count" className="text-white">{comped}</span> team{comped === 1 ? "" : "s"} currently comped from here.</p>
        </div>
        <div className="flex flex-col gap-2 sm:items-end">
          <div className="flex gap-1">
            {["All", "Granted", "Revoked"].map((f) => (
              <button key={f} data-testid={`comp-log-filter-${f.toLowerCase()}`} onClick={() => setFilter(f)} className={`rounded-full px-3.5 py-1.5 text-xs font-semibold ${filter === f ? "bg-[#39FF14] text-[#0A0E1A]" : "bg-[#162032] text-slate-300"}`}>{f}</button>
            ))}
          </div>
          <input data-testid="comp-log-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter by team or coach" className="w-full rounded-full border border-[#1E293B] bg-[#0A0E1A] px-4 py-2 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#39FF14] sm:w-64" />
        </div>
      </div>
      {loading ? <Loader /> : error ? <ErrorNote error={error} /> : !rows.length ? <Empty title="No changes yet" text="Turn free access on or off above and it's recorded here." /> : (
        <ol className="space-y-2">
          {rows.map((e) => (
            <li key={e.id} data-testid={`comp-log-entry-${e.id}`} className="grid gap-1 rounded-xl border border-[#1E293B] bg-[#0A0E1A] px-4 py-3 sm:grid-cols-[110px_1fr_auto] sm:items-center sm:gap-4">
              <span className={`w-fit rounded-full px-2.5 py-0.5 font-mono-gd text-[11px] uppercase tracking-wider ring-1 ${e.enabled ? "bg-[#39FF14]/15 text-[#39FF14] ring-[#39FF14]/40" : "bg-[#FF3B30]/15 text-red-200 ring-[#FF3B30]/40"}`}>{e.enabled ? "Granted" : "Revoked"}</span>
              <div className="min-w-0">
                <p className="truncate font-semibold text-white">{e.team_name ?? e.team_id}</p>
                <p className="truncate text-sm text-slate-400">{e.owner_name ?? "Coach"}{e.owner_email ? ` · ${e.owner_email}` : ""}</p>
              </div>
              <p className="font-mono-gd text-xs text-slate-400 sm:text-right">{when(e.at)}<br className="hidden sm:block" /><span className="sm:hidden"> · </span>by {e.by_name ?? e.by_email}</p>
            </li>
          ))}
        </ol>
      )}
    </Panel>
  );
}
